// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__b7Gzm","modal__list":"style_modal__list__yykvR","modal__close":"style_modal__close__AcK-M"};